import { render, staticRenderFns } from "./ProkurorKlubi.vue?vue&type=template&id=42768700&"
import script from "./ProkurorKlubi.vue?vue&type=script&lang=js&"
export * from "./ProkurorKlubi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports